import React from "react";
import ElementTile from "./ElementTile";
import "./PeriodicTable.css";

// Example: Just a few elements to demo. Replace with your full dataset.
const elements = [
  { number: 1,  symbol: "H",  name: "Hydrogen",     mass: "1.008" },
  { number: 2,  symbol: "He", name: "Helium",       mass: "4.0026" },
  { number: 3,  symbol: "Li", name: "Lithium",      mass: "6.94" },
  { number: 4,  symbol: "Be", name: "Beryllium",    mass: "9.0122" },
  { number: 5,  symbol: "B",  name: "Boron",        mass: "10.81" },
  { number: 6,  symbol: "C",  name: "Carbon",       mass: "12.011" },
  { number: 7,  symbol: "N",  name: "Nitrogen",     mass: "14.007" },
  { number: 8,  symbol: "O",  name: "Oxygen",       mass: "15.999" },
  { number: 9,  symbol: "F",  name: "Fluorine",     mass: "18.998" },
  { number: 10, symbol: "Ne", name: "Neon",         mass: "20.180" },
  { number: 11, symbol: "Na", name: "Sodium",       mass: "22.990" },
  { number: 12, symbol: "Mg", name: "Magnesium",    mass: "24.305" },
  { number: 13, symbol: "Al", name: "Aluminum",     mass: "26.982" },
  { number: 14, symbol: "Si", name: "Silicon",      mass: "28.085" },
  { number: 15, symbol: "P",  name: "Phosphorus",   mass: "30.974" },
  { number: 16, symbol: "S",  name: "Sulfur",       mass: "32.06" },
  { number: 17, symbol: "Cl", name: "Chlorine",     mass: "35.45" },
  { number: 18, symbol: "Ar", name: "Argon",        mass: "39.948" },
  { number: 19, symbol: "K",  name: "Potassium",    mass: "39.098" },
  { number: 20, symbol: "Ca", name: "Calcium",      mass: "40.078" },
  { number: 21, symbol: "Sc", name: "Scandium",     mass: "44.956" },
  { number: 22, symbol: "Ti", name: "Titanium",     mass: "47.867" },
  { number: 23, symbol: "V",  name: "Vanadium",     mass: "50.942" },
  { number: 24, symbol: "Cr", name: "Chromium",     mass: "51.996" },
  { number: 25, symbol: "Mn", name: "Manganese",    mass: "54.938" },
  { number: 26, symbol: "Fe", name: "Iron",         mass: "55.845" },
  { number: 27, symbol: "Co", name: "Cobalt",       mass: "58.933" },
  { number: 28, symbol: "Ni", name: "Nickel",       mass: "58.693" },
  { number: 29, symbol: "Cu", name: "Copper",       mass: "63.546" },
  { number: 30, symbol: "Zn", name: "Zinc",         mass: "65.38" },
  { number: 31, symbol: "Ga", name: "Gallium",      mass: "69.723" },
  { number: 32, symbol: "Ge", name: "Germanium",    mass: "72.630" },
  { number: 33, symbol: "As", name: "Arsenic",      mass: "74.922" },
  { number: 34, symbol: "Se", name: "Selenium",     mass: "78.971" },
  { number: 35, symbol: "Br", name: "Bromine",      mass: "79.904" },
  { number: 36, symbol: "Kr", name: "Krypton",      mass: "83.798" },
  { number: 37, symbol: "Rb", name: "Rubidium",     mass: "85.468" },
  { number: 38, symbol: "Sr", name: "Strontium",    mass: "87.62" },
  { number: 39, symbol: "Y",  name: "Yttrium",      mass: "88.906" },
  { number: 40, symbol: "Zr", name: "Zirconium",    mass: "91.224" },
  { number: 41, symbol: "Nb", name: "Niobium",      mass: "92.906" },
  { number: 42, symbol: "Mo", name: "Molybdenum",   mass: "95.95" },
  { number: 43, symbol: "Tc", name: "Technetium",   mass: "[98]" },
  { number: 44, symbol: "Ru", name: "Ruthenium",    mass: "101.07" },
  { number: 45, symbol: "Rh", name: "Rhodium",      mass: "102.91" },
  { number: 46, symbol: "Pd", name: "Palladium",    mass: "106.42" },
  { number: 47, symbol: "Ag", name: "Silver",       mass: "107.87" },
  { number: 48, symbol: "Cd", name: "Cadmium",      mass: "112.41" },
  { number: 49, symbol: "In", name: "Indium",       mass: "114.82" },
  { number: 50, symbol: "Sn", name: "Tin",          mass: "118.71" },
  { number: 51, symbol: "Sb", name: "Antimony",     mass: "121.76" },
  { number: 52, symbol: "Te", name: "Tellurium",    mass: "127.60" },
  { number: 53, symbol: "I",  name: "Iodine",       mass: "126.90" },
  { number: 54, symbol: "Xe", name: "Xenon",        mass: "131.29" },
  { number: 55, symbol: "Cs", name: "Cesium",       mass: "132.91" },
  { number: 56, symbol: "Ba", name: "Barium",       mass: "137.33" },
  { number: 57, symbol: "La", name: "Lanthanum",    mass: "138.91" },
  { number: 58, symbol: "Ce", name: "Cerium",       mass: "140.12" },
  { number: 59, symbol: "Pr", name: "Praseodymium", mass: "140.91" },
  { number: 60, symbol: "Nd", name: "Neodymium",    mass: "144.24" },
  { number: 61, symbol: "Pm", name: "Promethium",   mass: "[145]" },
  { number: 62, symbol: "Sm", name: "Samarium",     mass: "150.36" },
  { number: 63, symbol: "Eu", name: "Europium",     mass: "151.96" },
  { number: 64, symbol: "Gd", name: "Gadolinium",   mass: "157.25" },
  { number: 65, symbol: "Tb", name: "Terbium",      mass: "158.93" },
  { number: 66, symbol: "Dy", name: "Dysprosium",   mass: "162.50" },
  { number: 67, symbol: "Ho", name: "Holmium",      mass: "164.93" },
  { number: 68, symbol: "Er", name: "Erbium",       mass: "167.26" },
  { number: 69, symbol: "Tm", name: "Thulium",      mass: "168.93" },
  { number: 70, symbol: "Yb", name: "Ytterbium",    mass: "173.05" },
  { number: 71, symbol: "Lu", name: "Lutetium",     mass: "174.97" },
  { number: 72, symbol: "Hf", name: "Hafnium",      mass: "178.49" },
  { number: 73, symbol: "Ta", name: "Tantalum",     mass: "180.95" },
  { number: 74, symbol: "W",  name: "Tungsten",     mass: "183.84" },
  { number: 75, symbol: "Re", name: "Rhenium",      mass: "186.21" },
  { number: 76, symbol: "Os", name: "Osmium",       mass: "190.23" },
  { number: 77, symbol: "Ir", name: "Iridium",      mass: "192.22" },
  { number: 78, symbol: "Pt", name: "Platinum",     mass: "195.08" },
  { number: 79, symbol: "Au", name: "Gold",         mass: "196.97" },
  { number: 80, symbol: "Hg", name: "Mercury",      mass: "200.59" },
  { number: 81, symbol: "Tl", name: "Thallium",     mass: "204.38" },
  { number: 82, symbol: "Pb", name: "Lead",         mass: "207.2" },
  { number: 83, symbol: "Bi", name: "Bismuth",      mass: "208.98" },
  { number: 84, symbol: "Po", name: "Polonium",     mass: "[209]" },
  { number: 85, symbol: "At", name: "Astatine",     mass: "[210]" },
  { number: 86, symbol: "Rn", name: "Radon",        mass: "[222]" },
  { number: 87, symbol: "Fr", name: "Francium",     mass: "[223]" },
  { number: 88, symbol: "Ra", name: "Radium",       mass: "[226]" },
  { number: 89, symbol: "Ac", name: "Actinium",     mass: "227" },
  { number: 90, symbol: "Th", name: "Thorium",      mass: "232.04" }
];

export default function PeriodicTable({ onElementSelect, selectedSymbol }) {
  return (
    <div className="periodic-table-grid">
      {elements.map((el) => (
        <ElementTile
          key={el.number}
          {...el}
          isSelected={el.symbol === selectedSymbol}
          onClick={() => onElementSelect && onElementSelect(el.symbol)}
        />
      ))}
    </div>
  );
}
